import getElementDimension from './getElementDimension';

export const getElementWidth = (
	element,
	outer = false,
	includeMargin = false,
) => (
	getElementDimension('width', element, outer, includeMargin)
);

export default getElementWidth;
